import BaseType from "../BaseType";
import Guid from "../Guid";

export default class AwardLocale extends BaseType {
  AwardId: string = Guid.Empty;
  Locale: string = "";
  Name: string = "";
  Description = "";
}
